import React from 'react';

import Carousel from 'react-multi-carousel';

import team from '../../data/team';

function Team() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1150 },
      items: 3.5
    },
    midi_desktop: {
      breakpoint: { max: 1150, min: 980 },
      items: 3.1
    },
    mini_desktop: {
      breakpoint: { max: 980, min: 890 },
      items: 2.8
    },
    tablet: {
      breakpoint: { max: 890, min: 770 },
      items: 2.4
    },
    midi_tablet: {
      breakpoint: { max: 770, min: 690 },
      items: 2.1
    },
    mini_tablet: {
      breakpoint: { max: 690, min: 540 },
      items: 1.7
    },
    mobile: {
      breakpoint: { max: 540, min: 485 },
      items: 1.5
    },
    midi_mobile: {
      breakpoint: { max: 485, min: 400 },
      items: 1.2
    },
    mini_mobile: {
      breakpoint: { max: 400, min: 0 },
      items: 1
    }
  };

  return (
    <section className="relative w-full mb-28 sm:mb-52">
      <div className="content">
        <div className="max-w-5xl mx-auto text-center mb-10 sm:mb-16">
          <h1 className="section-header">Meet The Team</h1>
          <p className="big-p">
            The Purple Academy Team has extensive experience in Learning and Development,
            Instructional Design, Curriculum and Content Development, Digital Learning,
            Programme Execution, Facilitation, Coaching and Team Building.
          </p>
        </div>
        <div className="w-full">
          <Carousel
            arrows
            infinite
            autoPlay
            autoPlaySpeed={2500}
            responsive={responsive}
            centerMode={false}
            customTransition="transform 0.5s ease-in-out"
            transitionDuration={500}
            removeArrowOnDeviceType={['tablet', 'mobile']}
          >
            {team.map((item) => (
              <div
                key={item.name}
                className="group mx-2 rounded-2xl overflow-hidden relative h-[380px] shadow-lg"
                style={{ background: '#980B80' }}
              >
                <img
                  src={item.img}
                  alt={item.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ objectPosition: item.objectPosition || 'top center' }}
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-1 group-hover:translate-y-0 transition-transform duration-300">
                  <div className="w-8 h-[3px] bg-primary mb-2 rounded-full" />
                  <h3 className="font-bold font-title text-white text-base leading-tight">{item.name}</h3>
                  <p className="text-[12px] text-white/80 leading-snug mt-0.5">{item.role}</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default Team;
